<template>
  <a-card :bordered="false">
    <div v-html='content'></div>
  </a-card>
</template>

<script>
import { downFile, getAction, postAction } from '@/api/manage'

  export default {
    name: "DepositTemplate",
    components: {},
    data() {
      return {
        description: '保证金流水',
        loading:true,
        content: "",
      }
    },
    computed: {},
    props: ['checkId'],
    methods: {
      setBidProjectId(tenderId,sectionId) {
        let that = this;
        this.bidProjectId = tenderId
        this.loading = true;
        getAction("/ebid-ce/tmBidSection/queryByBidProjectId",{bidProjectId:tenderId}).then(res=> {
          if (res.success) {
            if(res.result.length > 0){
              if (sectionId != null) {
                that.loadContent(sectionId);
              } else {
                that.loadContent(res.result[0].id);
              }
            }
          }
        });
      },
      loadContent(sectionId) {
        postAction("/ebid-ce/depositTemplate/report/" + sectionId, {}).then(res=>{
          this.content = res;
          this.loading = false
        }).catch(err => {
          console.log(err);
          this.loading = false
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>